import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    createBusinessUnit(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/business_units', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateBusinessUnit(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/business_units/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBusinessUnits(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/business_units', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}